module.exports = __webpack_public_path__ + "resource/img/image053.fbccea19.png";